module.exports = "/img/story-1.c18047b9.png";